import './styles/unlockDialog.css';
import Btn from '../../subcomponents/Btn';
import { buyColor } from '../../utils/iapHelper';
import { FoundColor, IAPColor } from '@/types/types';
import Tile from '../../subcomponents/Tile';
import MiniDialog from '../../subcomponents/MiniDialog';
import { toast } from 'react-hot-toast';
import CustomToast from '../../subcomponents/Toast';
import { useState } from 'react';
import { type PurchaseStatus } from '../../utils/iapHelper';

type UnlockDialogProps = {
  open: boolean;
  onClose: () => void;
  unlockColor: FoundColor;
  letters: string[];
  unlockColorId: IAPColor;
  price: string;
};

function UnlockDialog(props: UnlockDialogProps) {
  const { open, onClose, unlockColor, letters, unlockColorId, price } = props;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  async function handlePurchase() {
    setIsLoading(true);
    const status: PurchaseStatus = await buyColor(unlockColor, unlockColorId);
    setIsLoading(false);

    if (status === 'success') {
      toast.custom((t) => (
        <CustomToast t={t} message={`${unlockColor.toUpperCase()} animation unlocked`} star />
      ));
      onClose();
    } else if (status === 'cancelled') {
      toast.custom((t) => <CustomToast t={t} message="Purchase cancelled" warning />);
    } else if (status === 'error') {
      toast.custom((t) => <CustomToast t={t} message="Purchase failed" warning />);
    }
  }

  return (
    <MiniDialog open={open} onClose={onClose} title="UNLOCK">
      <div className="unlock-container">
        <div className="unlock-sibtitle">
          Unlock the <b>{unlockColor.toUpperCase()}</b> animation for {price}.
        </div>
        <div className="flex justify-center">
          {letters.map((letter, idx) => (
            <Tile value={letter} key={idx} medium {...{ [unlockColor]: true }} />
          ))}
        </div>
        <div className="flex justify-center mt-2">
          <Btn text="PURCHASE" onClick={handlePurchase} loading={isLoading} />
        </div>
      </div>
    </MiniDialog>
  );
}

export default UnlockDialog;
